import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getCountries } from "../../../store/middleware";

function InputForCountry({ name, data: { error, value, required }, inputChange }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    dispatch(getCountries()).then((res) => setCountries(res));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="input-country">
      <label className={error ? "invalid" : ""} htmlFor={name}>
        {t("COUNTRY")}
      </label>

      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <div className="select-wrapper">
        <select className={error ? "invalid" : ""} name={name} value={value} onChange={(e) => inputChange(e)}>
          <option value={""}> {t("SELECT")}</option>
          {countries &&
            countries.map((option) => (
              <option key={option.name} value={option.id}>
                {" "}
                {option.name}{" "}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
}

export default InputForCountry;
